$(document).ready(function () {
    const testimonialsSwiper = new Swiper('.testimonials__container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.testimonials__container .swiper-button-next',
            prevEl: '.testimonials__container .swiper-button-prev',
        },
        breakpoints: {
            1280: {
                slidesPerView: 2,
                spaceBetween: 55,
            },
        },
    })
})
